import type { TFunction } from "i18next";
import { messages } from "../../../../../locales/messages";
import { RestoreEligibility, RestoreReasonKey } from "./restoreEligibility";

type MessageFactory = () => ReturnType<typeof messages.Restore>;

/** Maps a "cannot restore" reason to the localized explanation message. */
export const RESTORE_REASON_KEY_TO_MESSAGE: Record<
  RestoreReasonKey,
  MessageFactory
> = {
  NOT_ACCEPTED: () => messages.Cannot_Restore_Not_Accepted(),
  MANUAL_SIGNAL: () => messages.Cannot_Restore_Manual_Signal(),
  RESTORE_OF_RESTORE: () => messages.Cannot_Restore_Already_Reverted(),
  NO_BEFORE: () => messages.Cannot_Restore_No_Before_Value(),
  FLYER_APPROVED: () => messages.Cannot_Restore_Flyer_Approved(),
};

/**
 * Tooltip text for the restore action: the plain "Restore" label when the
 * change request is restorable, otherwise the reason it is blocked. Shared by
 * `ChangeRequestRow` and `HistoryTree` (previously duplicated verbatim).
 */
export const resolveRestoreTooltip = (
  eligibility: RestoreEligibility,
  t: TFunction,
): string =>
  t(
    eligibility.ok
      ? messages.Restore()
      : eligibility.reasonKey
        ? RESTORE_REASON_KEY_TO_MESSAGE[eligibility.reasonKey]()
        : messages.Restore(),
  );
